// Special case selector that keeps an internal reference to state
// so we don't have to pass state or feature flags deep into code
let producesState;
import * as selector from 'user/selectors';

export const user = {};

export const createFlagCheck = ({ getState }) => {
  producesState = getState;
  Object.keys(selector).forEach( prop => {
    if( typeof selector[prop] !== 'function' ) { return; } // only mimic functions
    if( selector[prop].length !== 1) { return; } // ...with an arity of 1 (presumably state)
    user[prop] = () => selector[prop](producesState());
  });
};
